"use client";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAbout, selectAboutData } from "@/slice/aboutSlice";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import ReactMarkdown from "react-markdown";

const AboutPage = () => {
  const dispatch = useDispatch();
  const aboutData = useSelector(selectAboutData);
  const status = useSelector((state) => state.about.status);

  useEffect(() => {
    dispatch(fetchAbout());
  }, [dispatch]);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  if (status === "failed") {
    return <div>Error loading about data</div>;
  }

  const { title, description, about_section } = aboutData?.data || {};

  return (
    <div className="container mx-auto px-4 py-8
      xl:max-w-7xl xl:px-8 xl:py-12
      lg:max-w-6xl lg:px-6 lg:py-10
      md:max-w-4xl md:px-4 md:py-8
      sm:max-w-2xl sm:px-4 sm:py-6
      max-w-full px-4 py-4">
      <BreadCrumbs />
      <h1 className="text-3xl font-bold mb-6
        xl:text-5xl xl:mb-8
        lg:text-4xl lg:mb-7
        md:text-3xl md:mb-6
        sm:text-2xl sm:mb-5
        text-xl mb-4">{title}</h1>
      <p className="text-lg mb-8 text-justify
        xl:text-xl xl:mb-12 xl:leading-relaxed
        lg:text-lg lg:mb-10 lg:leading-relaxed
        md:text-base md:mb-8 md:leading-normal
        sm:text-sm sm:mb-6 sm:leading-normal
        text-sm mb-4 leading-normal">{description}</p>

      {about_section &&
        about_section.map((section, index) => (
          <div
            key={section.id}
            className={`p-5 ${index % 2 === 0 ? "bg-gray-100" : "bg-white"}
              xl:p-8 xl:rounded-lg xl:shadow-sm
              lg:p-7 lg:rounded-lg lg:shadow-sm
              md:p-6 md:rounded-md
              sm:p-5 sm:rounded-md
              p-4 rounded-md`}
          >
            <h2 className="text-2xl font-semibold mb-4
              xl:text-3xl xl:mb-6
              lg:text-2xl lg:mb-5
              md:text-xl md:mb-4
              sm:text-lg sm:mb-3
              text-base mb-3">{section.title}</h2>
            <ReactMarkdown className="prose max-w-none text-justify
              xl:prose-xl xl:leading-relaxed
              lg:prose-lg lg:leading-relaxed
              md:prose-base md:leading-normal
              sm:prose-sm sm:leading-normal
              prose-sm leading-normal">
              {section.description}
            </ReactMarkdown>
          </div>
        ))}
    </div>
  );
};

export default AboutPage;
